import mixpanel from "mixpanel-browser"
import { MIXPANEL_TOKEN } from "./constants"

class Tracker {
  init(clientId){
    if(!mixpanel.config && clientId){
      const mixpanelConfig = {
        ignore_dnt: true,
        loaded: (mixpanel) => {
          mixpanel.identify(clientId)
        }
      }
      mixpanel.init(MIXPANEL_TOKEN, mixpanelConfig)
    }
  }

  track = (event, parameters) => {
    mixpanel.config && mixpanel.track(event, parameters)
  }
}

const tracker = new Tracker()

export default tracker